import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import { useUserStore } from './stores/user';
import { MutationType } from 'pinia';
import { useRouter } from 'vue-router';
import { AxiosResponse } from 'axios';
import { useResultsStore } from './stores/citation-search-results';
import { useDisplay } from 'vuetify';
import { useCartStore } from './stores/cart';
import GlobalSnackbar from '@/components/Snackbar/snackbar-component.vue';
import GlobalProgressCircular from '@/components/ProgressCircular/progress-circular-component.vue';
import { injectStrict, AxiosKey, SnackbarKey } from '@/symbols';
import { usePaymentPortalConfigStore } from './stores/payment-portal-config';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/*global Server*/
const { smAndDown, mdAndUp } = useDisplay();
const cartStore = useCartStore();

const userStore = useUserStore();
const results = useResultsStore();
const isUserLoggedIn = ref(false);
const currentUser = ref(userStore.user);
const isLogoutPageLoading = ref(false);
const portalURL = process.env.VUE_APP_PORTAL_BASE_URL;
const mobileMenuDrawer = ref(false);
const router = useRouter();
const axios = injectStrict(AxiosKey);
const snackbar = injectStrict(SnackbarKey);
const paymentPortalConfigStore = usePaymentPortalConfigStore();
const currentURL = window.location.href;

const timeLeft = computed(() => {
    if (cartStore.checkoutTimer != null) {
        const miliLeft = (new Date(cartStore.checkoutTimer).getTime() + 3600000) - new Date().getTime();
        return miliLeft < 0 ? 0 : miliLeft;
    }
    return 0;
});


function checkoutTimerEnded(): void {
    cartStore.clearCart();
    cartStore.clearCheckoutTimer();
    results.clearResults();
    router.push({ name: 'search' });
}


function logout(): void {
    isLogoutPageLoading.value = true;

    axios.get('account/Logout')
        .then((response: AxiosResponse) => {
            if (response.status == 200) {
                // --- Remove the logged out user from session storage. --- //
                sessionStorage.removeItem('user');
                clearStores();

                window.location.href = portalURL + 'home';
            }
        })
        .catch(() => {
            snackbar.open('An error occurred while logging out. Please try again.', 5000, 'red');
        })
        .finally(() => {
            isLogoutPageLoading.value = false;
        });

}



function checkSession(): void {
    axios.get('Account/CheckSession')
        .then((response: AxiosResponse<Server.IUserAccount>) => {
            if (response.status == 200 && response.data.Id != null) {
                userStore.$patch({
                    user: response.data
                });
            }
        })
        .catch(() => {
            userStore.$patch({
                user: null as any
            });
        });
}

function getPaymentPortalConfig(): void {
    axios.get('ApplicatonMaintenance/GetApplicationConfig')
        .then((response: AxiosResponse) => {
            if (response.status == 200) {
                paymentPortalConfigStore.$patch({
                    paymentPortalConfiguration: response.data
                });
            }
        })
        .catch(() => {
            snackbar.open('An error occurred while processing your request. Please try again.', 5000, 'red');
        });
}

function clearStores() {
    // --- Reset the userStore to its initial state. --- //
    userStore.$reset();
}

const currentUrl = window.location.pathname;
if (currentUrl == '/login') {
    userStore.$patch({
        user: null as any
    });
    currentUser.value = null;
}

window.setInterval(() => {
    if (currentUser.value != null && Object.keys(currentUser.value).length > 0) {
        checkSession();
    }
}, 5 * 60000); // 5 * 1000 milliseconds


// --- Subscribe to the session storage to watch for patch updates to the store. This will then change the state of the menu. --- //
// --- https://pinia.vuejs.org/core-concepts/state.html#subscribing-to-the-state --- //
userStore.$subscribe((mutation, state) => {
    mutation.type = MutationType.patchObject;
    mutation.storeId = 'user';

    if (state.user != null && Object.keys(state.user).length > 0) {
        currentUser.value = state.user;
        isUserLoggedIn.value = true;
    }
    else {

        currentUser.value = null;
        isUserLoggedIn.value = false;
    }
});

getPaymentPortalConfig();
checkSession();



function initGoogleTranslate() {
    let googleTranslateInitScript = document.createElement('script');
    googleTranslateInitScript.text = "" +
        "function googleTranslateElementInit(){" +
        "new google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');" +
        "};"
    document.head.appendChild(googleTranslateInitScript)

    let googleTranslateScript = document.createElement('script');
    googleTranslateScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
    document.head.appendChild(googleTranslateScript)

    document.addEventListener('DOMContentLoaded', () => {

        // Get all "navbar-burger" elements
        const navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

        // Add a click event on each of them
        navbarBurgers.forEach(el => {
            el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const t = el.dataset.target;
                const target = document.getElementById(t);

                if (target != null) {
                    // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                    el.classList.toggle('is-active');
                    target.classList.toggle('is-active');

                }

            });
        });

    });
}

document.documentElement.lang = 'en';

initGoogleTranslate();

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_v_banner = _resolveComponent("v-banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_app_bar, {
              flat: "",
              color: "blue-grey-lighten-5",
              class: "border-b-sm border-grey",
              height: "93"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_app_bar_nav_icon, {
                  class: "hidden-md-and-up",
                  "aria-label": "mobile menu",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuDrawer.value = !mobileMenuDrawer.value))
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "text-blue-grey-darken-4 hidden-sm-and-down",
                  href: _unref(portalURL)
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Home", -1)
                  ]))]),
                  _: 1
                }, 8, ["href"]),
                (!isUserLoggedIn.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "text",
                      class: "text-blue-grey-darken-4 hidden-sm-and-down",
                      href: _unref(portalURL) + 'register'
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Create Account", -1)
                      ]))]),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (_unref(mdAndUp))
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      to: { name: 'cart' },
                      variant: "outlined",
                      "prepend-icon": "mdi-cart-outline",
                      height: "44",
                      class: "bg-grey-lighten-4"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_badge, {
                          color: "error",
                          content: _unref(cartStore).totalItemsInCart,
                          inline: ""
                        }, null, 8, ["content"])
                      ]),
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createTextVNode(" Cart ", -1))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: { name: 'cart' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_badge, {
                          location: "top right",
                          color: "error",
                          content: _unref(cartStore).totalItemsInCart,
                          class: "mr-7"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "black",
                              icon: "mdi-cart-outline"
                            })
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _: 1
                    })),
                (!isUserLoggedIn.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 3,
                      href: _unref(portalURL) + 'login' + '?ReturnURL=' + _unref(currentURL),
                      color: "primary",
                      variant: "flat",
                      class: "ml-6 mr-7 mr-md-14 hidden-sm-and-down"
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("Log In", -1)
                      ]))]),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (isUserLoggedIn.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 4,
                      id: "user-activator",
                      "prepend-icon": "mdi-account",
                      variant: "outlined",
                      class: "ml-14 mr-1 hidden-sm-and-down"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, { icon: "mdi-chevron-down" })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(userStore).user?.FirstName) + " ", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (isUserLoggedIn.value)
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 5,
                      "open-on-hover": "",
                      "open-on-click": "",
                      activator: "#user-activator",
                      class: "hidden-sm-and-down"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              href: _unref(portalURL) + 'account/profile'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-blue-grey-darken-4" }, {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("Account Information", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["href"]),
                            _createVNode(_component_v_list_item, {
                              href: _unref(portalURL) + 'payment-history'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-blue-grey-darken-4" }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("Payment History", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["href"]),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-blue-grey-darken-4" }, {
                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode("Logout", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, { class: "d-flex align-center ml-md-12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: '/' }, {
                      default: _withCtx(() => [
                        (_unref(smAndDown))
                          ? (_openBlock(), _createBlock(_component_v_img, {
                              key: 0,
                              "max-width": "61",
                              width: "61",
                              "max-height": "61",
                              class: "ml-2 mr-2 mb-4 mt-4",
                              alt: "Jefferson Parish Sheriff's Office Logo",
                              src: "./jpsoshield.png"
                            }))
                          : (_openBlock(), _createBlock(_component_v_img, {
                              key: 1,
                              "max-width": "278",
                              width: "278",
                              "max-height": "61",
                              class: "ml-2 mr-2 mb-4 mt-4",
                              alt: "Jefferson Parish Sheriff's Office Logo",
                              src: "./logo.png"
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_navigation_drawer, {
              modelValue: mobileMenuDrawer.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mobileMenuDrawer).value = $event)),
              app: "",
              temporary: "",
              class: "hidden-md-and-up"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { nav: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      title: "Home",
                      class: "text-blue-grey-darken-4",
                      href: _unref(portalURL)
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, { icon: "mdi-home-outline" })
                      ]),
                      _: 1
                    }, 8, ["href"]),
                    (!isUserLoggedIn.value)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          title: "Create Account",
                          class: "text-blue-grey-darken-4",
                          href: _unref(portalURL) + 'register'
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-account-plus-outline" })
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item, {
                      to: { name: 'cart' },
                      title: "Cart",
                      class: "text-blue-grey-darken-4"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, { icon: "mdi-cart-outline" })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_v_badge, {
                          color: "error",
                          content: _unref(cartStore).totalItemsInCart,
                          inline: ""
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    }),
                    (!isUserLoggedIn.value)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          title: "Log In",
                          href: _unref(portalURL) + 'login' + '?ReturnURL=' + _unref(currentURL),
                          color: "primary"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-login" })
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : _createCommentVNode("", true),
                    (isUserLoggedIn.value)
                      ? (_openBlock(), _createBlock(_component_v_list_group, {
                          key: 2,
                          value: _unref(userStore).user?.FirstName
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_list_item, _mergeProps({
                              title: _unref(userStore).user?.FirstName
                            }, props), {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi-account" })
                              ]),
                              _: 1
                            }, 16, ["title"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              href: _unref(portalURL) + 'account/profile'
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi-account-cog-outline" })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-blue-grey-darken-4" }, {
                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("Profile", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["href"]),
                            _createVNode(_component_v_list_item, {
                              href: _unref(portalURL) + 'payment-history'
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi-account-cash-outline" })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-blue-grey-darken-4" }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("Payment History", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["href"]),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (logout()))
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi-logout" })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-blue-grey-darken-4" }, {
                                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createTextVNode("Logout", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_main, { class: "bg-grey-lighten-5" }, {
              default: _withCtx(() => [
                (_unref(cartStore).checkoutTimer != null)
                  ? (_openBlock(), _createBlock(_component_v_banner, {
                      key: 0,
                      sticky: "",
                      "max-height": "70",
                      class: "pb-8",
                      "bg-color": "grey-lighten-3"
                    }, {
                      text: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_vue_countdown, {
                            time: timeLeft.value,
                            onEnd: checkoutTimerEnded
                          }, {
                            default: _withCtx(({ minutes, seconds }) => [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "is-block-mobile" }, "Checkout Time Remaining：", -1)),
                              _cache[16] || (_cache[16] = _createTextVNode()),
                              _createElementVNode("span", null, _toDisplayString(minutes) + " minutes, " + _toDisplayString(seconds) + " seconds.", 1)
                            ]),
                            _: 1
                          }, 8, ["time"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_view)
              ]),
              _: 1
            }),
            _createVNode(GlobalSnackbar),
            _createVNode(GlobalProgressCircular)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_o_loading, {
      active: isLogoutPageLoading.value,
      "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((isLogoutPageLoading).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_icon, {
          pack: "fa",
          icon: "spinner",
          size: "large",
          spin: "",
          variant: "primary"
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { id: "google-translate-container" }, [
      _createElementVNode("div", { id: "google_translate_element" })
    ], -1))
  ], 64))
}
}

})